import React from 'react'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import TrackingGuidelines from 'components/Patients/PatientGuidelines/TrackingGuidelines'
import AISuggestionSection from '../AISuggestionSection'

const RelevantPracticeGuidelines = ({ categories, filteredCategoriesByTrackingDetails }) => {
  const { t } = useTranslation()

  const shouldDisplayRelevantPG = !isEmpty(filteredCategoriesByTrackingDetails) && categories.length > 0

  return shouldDisplayRelevantPG ? (
    <AISuggestionSection title={t('pages.patients.selectedPatient.chat.gi.relevantPracticeGuidelines.title')}>
      <TrackingGuidelines categories={categories} categoriesData={filteredCategoriesByTrackingDetails} />
    </AISuggestionSection>
  ) : (
    <></>
  )
}

export default RelevantPracticeGuidelines
